export default {
  state: {
    visibility: false
  },
  mutations: {
    SET_ADD_BOTTOM_MENU_ITEM_DIALOG_VISIBILITY(state, payload) {
      state.visibility = payload
    }
  },
  actions: {}
}
